import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamento = () => import('./Pagamento.vue')

export default {
    path: 'pagamentos',
    name: 'GesconAprovadoresPagamento',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-APR-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'GesconAprovadoresPagamentoDetalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-APR-PAG-01')) {
                    next()
                }
            }
        }
    ]
}